export default "__VITE_ASSET__c88213a4__"